import { useMutation } from 'react-query';
import React from 'react';
import api from '../../../../components/api';

function useRenderCardProduct(refetch : () => void) {
  const [result, setResult] = React.useState<any>(undefined);
  const { isLoading, mutate } = useMutation(api.product.deleteByColumn, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      alert('success');
      console.log('suc delete', data);
      setResult(data);
    },
    onError: (error) => {
      alert('error');
      console.log('error', error);
    },
  });

  const handleDelete = (id: number) => mutate(id.toString());
  const afterDelete = () => {
    refetch();
    setResult(undefined);
  };

  return {
    handleDelete,
    afterDelete,
    isLoading,
    result,
  };
}

export default useRenderCardProduct;
